"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersModule = void 0;
const router_1 = require("client/components/router");
const billing_sheet_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/billing-sheet");
const claim_label_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/claim-label");
const invoice_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/invoice");
const monographs_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/monographs");
const patient_waiver_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/patient-waiver");
const pharmacy_label_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/pharmacy-label");
const print_labels_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/print-labels");
const warning_info_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/warning-info");
const warning_label_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/warning-label");
const orders_create_1 = require("./modules/orders-create");
const orders_detail_1 = require("./modules/orders-detail");
const orders_list_1 = require("./modules/orders-list");
const orders_queue_1 = require("./modules/orders-queue");
const orders_submit_1 = require("./modules/orders-submit");
const orders_submit_map_header_1 = require("./modules/orders-submit-map-header");
const orders_submit_preview_1 = require("./modules/orders-submit-preview");
const orders_submit_select_header_1 = require("./modules/orders-submit-select-header");
class OrdersModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("list", /^\/claims\/?$/, orders_list_1.OrdersList);
        this.addRoute("submit", /^\/claims\/submit\/?(\d+)?$/, orders_submit_1.OrdersSubmit);
        this.addRoute("submit/select", /^\/claims\/submit\/select\/?(\d+)?$/, orders_submit_select_header_1.OrdersSubmitSelectHeader);
        this.addRoute("submit/map", /^\/claims\/submit\/map\/?(\d+)?$/, orders_submit_map_header_1.OrdersSubmitMapHeader);
        this.addRoute("submit/preview", /^\/claims\/submit\/preview\/?(\d+)?$/, orders_submit_preview_1.OrdersSubmitPreview);
        this.addRoute("billing-sheet", /^\/claims\/(\d+)\/billing-sheet\/(\d+)$/, billing_sheet_1.BillingSheet);
        this.addRoute("claim-label", /^\/claims\/(\d+)\/claim-label\/(\d+)$/, claim_label_1.ClaimLabel);
        this.addRoute("invoice", /^\/claims\/(\d+)\/invoice\/(\d+)$/, invoice_1.Invoice);
        this.addRoute("monographs", /^\/claims\/(\d+)\/monographs\/(\d+)$/, monographs_1.Monographs);
        this.addRoute("patient-waiver", /^\/claims\/(\d+)\/patient-waiver\/(\d+)$/, patient_waiver_1.PatientWaiver);
        this.addRoute("pharmacy-label", /^\/claims\/(\d+)\/pharmacy-label\/(\d+)$/, pharmacy_label_1.PharmacyLabel);
        this.addRoute("print-labels", /^\/claims\/(\d+)\/print-labels\/(\d+)$/, print_labels_1.PrintLabels);
        this.addRoute("warning-info", /^\/claims\/(\d+)\/warning-info\/(\d+)$/, warning_info_1.WarningInfo);
        this.addRoute("warning-label", /^\/claims\/(\d+)\/warning-label\/(\d+)$/, warning_label_1.WarningLabel);
        this.addRoute("detail", /^\/claims\/(\d+)/, orders_detail_1.OrdersDetail);
        this.addRoute("create", /^\/claims\/new\/?(\d+)?$/, orders_create_1.OrdersCreate);
        this.addRoute("queue", /^\/claims\/queue\/?(\d+)?$/, orders_queue_1.OrdersQueue);
    }
}
exports.OrdersModule = OrdersModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/orders.tsx
// module id = 3722
// module chunks = 0